import { render, staticRenderFns } from "./LinkToPDFWidget.vue?vue&type=template&id=59761dc2&"
import script from "./LinkToPDFWidget.vue?vue&type=script&lang=js&"
export * from "./LinkToPDFWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports